var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "media-info-icons info row" }, [
    _c(
      "div",
      { staticClass: "views d-flex", class: { active: _vm.post.my_xp.seen } },
      [
        _c("span", { staticClass: "dashicons dashicons-visibility" }),
        _c("span", { staticClass: "count" }, [
          _vm._v(_vm._s(_vm.post.stats.views || 0)),
        ]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "likes d-flex",
        class: { active: _vm.post.my_xp.like },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.likePost.apply(null, arguments)
          },
        },
      },
      [
        _c("span", { staticClass: "dashicons dashicons-thumbs-up" }),
        _c("span", { staticClass: "count" }, [
          _vm._v(_vm._s(_vm.post.stats.likes || 0)),
        ]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "dislikes d-flex",
        class: { active: _vm.post.my_xp.dislike },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.dislikePost.apply(null, arguments)
          },
        },
      },
      [
        _c("span", { staticClass: "dashicons dashicons-thumbs-down" }),
        _c("span", { staticClass: "count" }, [
          _vm._v(_vm._s(_vm.post.stats.dislikes || 0)),
        ]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "favs d-flex",
        class: [{ active: _vm.post.my_xp.fav }],
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.favPost.apply(null, arguments)
          },
        },
      },
      [
        _c("span", { staticClass: "dashicons dashicons-star-filled" }),
        _c("span", { staticClass: "count" }, [
          _vm._v(_vm._s(_vm.post.stats.favs || 0)),
        ]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "comments d-flex",
        class: { active: _vm.post.my_xp.comment },
      },
      [
        _c("span", { staticClass: "dashicons dashicons-admin-comments" }),
        _c("span", { staticClass: "count" }, [
          _vm._v(_vm._s(_vm.post.stats.comments || 0)),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }